import { OktaAuth } from '@okta/okta-auth-js';

const CLIENT_ID = process.env.P_CLIENT_ID;
const ISSUER = process.env.P_ISSUER;

export const oktaAuth = new OktaAuth({
  clientId: CLIENT_ID,
  issuer: ISSUER,
  redirectUri: `${window.origin}/callback`,
  scopes: ['openid', 'profile', 'abtoolsAdGroups'],
  pkce: true,
});

/**
 * @method systemUser
 * @description added system user details for development purpose(env.local is true)
 */
export const systemUser = () => ({
  name: 'ABTools System Admin',
  email: 'sysadmin@jd.com',
  abtoolsAdGroups: ['ABTOOLS_SYSTEM_ADMIN'],
  userID: process.env.TEST_ID,
});

export const systemUserCreditAnalyst = () => ({
  name: 'ABTools Credit Analyst',
  email: 'sysadmin@jd.com',
  abtoolsAdGroups: ['ABTOOLS_CREDIT_ANALYST'],
  userID: process.env.TEST_ID,
});

export const systemUserProcessingStaff = () => ({
  name: 'ABTools Processing Staff',
  email: 'sysadmin@jd.com',
  abtoolsAdGroups: ['ABTOOLS_PROCESSING_STAFF'],
  userID: process.env.TEST_ID,
});
